// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_cabinet__OrgSwitcher from "../OrgSidebar/OrgSwitcher.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_cabinet__SidebarDocuments from "./SidebarDocuments.js";
import * as Buhta_cabinet__SidebarHrm from "./SidebarHrm.js";
import * as Buhta_cabinet__SidebarItem from "./SidebarItem.js";
import * as Buhta_cabinet__SidebarKassa from "./SidebarKassa.js";
import * as Buhta_cabinet__SidebarManage from "./SidebarManage.js";
import * as Buhta_cabinet__SidebarPayroll from "./SidebarPayroll.js";
import * as Buhta_cabinet__SidebarSettings from "./SidebarSettings.js";
import * as Buhta_cabinet__SidebarTaxes from "./SidebarTaxes.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Auth from "../../../../../../packages/core/lib/Auth.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(org) {
  return function (onClose) {
    return function (setIsDropdownShown) {
      return function (setBar) {
        return function (sidebarItems) {
          const match = Buhta_core__Auth.IdentityContext.useIdentity(undefined);
          const identity = match[0];
          const match$1 = Buhta_core__Tenant.useTenant(undefined);
          const tenant = match$1[0];
          const contextRoute = function (route) {
            return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
          };
          let userpic;
          let exit = 0;
          if (typeof identity === "number" || identity.TAG !== /* Authorized */0) {
            exit = 1;
          } else {
            const identityProfile = identity._0;
            userpic = identityProfile.userpic_url === "" ? JsxRuntime.jsx("div", {
                    children: identityProfile.first_name.substring(0, 1),
                    className: "w-5 h-5 rounded-full bg-asphalt flex justify-center items-center text-white text-xs font-semibold"
                  }) : JsxRuntime.jsx("img", {
                    className: "w-5 h-5 rounded-50pct",
                    src: identityProfile.userpic_url
                  });
          }
          if (exit === 1) {
            userpic = JsxRuntime.jsx("img", {
                  className: "w-5 h-5 rounded-50pct",
                  src: StaticAsset.src("/static/icons/profile-photo.png")
                });
          }
          let fullName;
          if (typeof identity === "number" || identity.TAG !== /* Authorized */0) {
            fullName = "Профиль";
          } else {
            const identityProfile$1 = identity._0;
            fullName = identityProfile$1.first_name + (" " + identityProfile$1.last_name);
          }
          return JsxRuntime.jsxs(React.Fragment, {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(sidebarItems, (function (index, item) {
                                          const Key = "sidebar__item_" + String(index);
                                          return JsxRuntime.jsx(Buhta_cabinet__SidebarItem.make, {
                                                      item: item,
                                                      onClose: onClose,
                                                      setBar: setBar
                                                    }, Key);
                                        }))),
                              className: "mt-6"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_cabinet__SidebarItem.make, {
                                      item: {
                                        label: "Настройки",
                                        route: contextRoute({
                                              TAG: /* Settings */8,
                                              _0: /* General */0
                                            }),
                                        isActiveRoute: (function (param) {
                                            if (typeof param === "number" || param.TAG !== /* Settings */8) {
                                              return false;
                                            } else {
                                              return true;
                                            }
                                          }),
                                        eventName: "",
                                        bar: "settings",
                                        isHidden: false
                                      },
                                      setBar: setBar
                                    }, "sidebar__item_settings"),
                                JsxRuntime.jsxs("button", {
                                      children: [
                                        userpic,
                                        JsxRuntime.jsx(Buhta_components__Text.P.make, {
                                              className: "ml-4 text-gray-medium",
                                              children: fullName
                                            })
                                      ],
                                      className: "flex py-1.5 px-6 items-center",
                                      onClick: (function (param) {
                                          Curry._1(setIsDropdownShown, (function (param) {
                                                  return true;
                                                }));
                                        })
                                    })
                              ],
                              className: "absolute bottom-6 space-y-2 w-full"
                            })
                      ]
                    });
        };
      };
    };
  };
}

function SidebarMobile$SidebarMain(Props) {
  return Curry._3(make(Props.org)(Props.onClose), Props.setIsDropdownShown, Props.setBar, Props.sidebarItems);
}

const SidebarMain = {
  make: SidebarMobile$SidebarMain
};

function make$1(org) {
  return function (isOpen) {
    return function (onClose) {
      return function (sidebarItems) {
        const match = Buhta_core__Tenant.useTenant(undefined);
        const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
        const deviceType = state.deviceType;
        const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
        const currentUrlStr = Buhta_cabinet__Route.toString(currentRoute);
        const match$1 = React.useState(function () {
              return false;
            });
        const setIsDropdownShown = match$1[1];
        const match$2 = React.useState(function () {
              if (typeof currentRoute === "number") {
                return "main";
              }
              switch (currentRoute.TAG | 0) {
                case /* Org */6 :
                    let tmp = currentRoute._1;
                    if (typeof tmp === "number") {
                      return "main";
                    }
                    switch (tmp.TAG | 0) {
                      case /* Documents */1 :
                          return "documents";
                      case /* Kassa */2 :
                          return "kassa";
                      case /* Tax */4 :
                          return "taxes";
                      case /* Hrm */5 :
                          return "hrm";
                      case /* Payroll */6 :
                          return "payroll";
                      case /* Manage */7 :
                          return "manage";
                      case /* Settings */8 :
                          return "settings";
                      default:
                        return "main";
                    }
                case /* Admin */7 :
                    const match = currentRoute._0;
                    if (typeof match === "number") {
                      return "main";
                    }
                    if (match.TAG !== /* Orgs */1) {
                      return "main";
                    }
                    const match$1 = match._0;
                    if (typeof match$1 === "number") {
                      return "main";
                    }
                    let tmp$1 = match$1._1;
                    if (typeof tmp$1 === "number") {
                      return "main";
                    }
                    switch (tmp$1.TAG | 0) {
                      case /* Kassa */2 :
                          return "kassa";
                      case /* Payroll */6 :
                          return "payroll";
                      case /* Manage */7 :
                          return "manage";
                      default:
                        return "main";
                    }
                default:
                  return "main";
              }
            });
        const setBar = match$2[1];
        const match$3 = match[0].ctx;
        let tmp;
        switch (match$2[0]) {
          case "documents" :
              tmp = JsxRuntime.jsx(Buhta_cabinet__SidebarDocuments.make, {
                    org: org,
                    currentRoute: currentRoute,
                    setBar: setBar
                  });
              break;
          case "hrm" :
              tmp = JsxRuntime.jsx(Buhta_cabinet__SidebarHrm.make, {
                    setBar: setBar,
                    currentRoute: currentRoute,
                    org: org,
                    setIsDropdownShown: setIsDropdownShown
                  });
              break;
          case "kassa" :
              tmp = deviceType === "mobile" ? JsxRuntime.jsx(SidebarMobile$SidebarMain, {
                      org: org,
                      onClose: onClose,
                      setIsDropdownShown: setIsDropdownShown,
                      setBar: setBar,
                      sidebarItems: sidebarItems
                    }) : JsxRuntime.jsx(Buhta_cabinet__SidebarKassa.make, {
                      org: org,
                      currentRoute: currentRoute,
                      setBar: setBar,
                      setIsDropdownShown: setIsDropdownShown
                    });
              break;
          case "manage" :
              tmp = JsxRuntime.jsx(Buhta_cabinet__SidebarManage.make, {
                    org: org,
                    currentRoute: currentRoute,
                    setBar: setBar,
                    setIsDropdownShown: setIsDropdownShown
                  });
              break;
          case "payroll" :
              tmp = JsxRuntime.jsx(Buhta_cabinet__SidebarPayroll.make, {
                    org: org,
                    currentRoute: currentRoute,
                    setBar: setBar,
                    setIsDropdownShown: setIsDropdownShown
                  });
              break;
          case "settings" :
              tmp = JsxRuntime.jsx(Buhta_cabinet__SidebarSettings.make, {
                    org: org,
                    currentRoute: currentRoute,
                    setBar: setBar,
                    setIsDropdownShown: setIsDropdownShown
                  });
              break;
          case "taxes" :
              tmp = JsxRuntime.jsx(Buhta_cabinet__SidebarTaxes.make, {
                    setBar: setBar,
                    currentRoute: currentRoute,
                    org: org,
                    setIsDropdownShown: setIsDropdownShown
                  });
              break;
          default:
            tmp = JsxRuntime.jsx(SidebarMobile$SidebarMain, {
                  org: org,
                  onClose: onClose,
                  setIsDropdownShown: setIsDropdownShown,
                  setBar: setBar,
                  sidebarItems: sidebarItems
                });
        }
        return JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    match$3 ? JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
                                            route: {
                                              TAG: /* Admin */7,
                                              _0: {
                                                TAG: /* Orgs */1,
                                                _0: /* List */0
                                              }
                                            },
                                            className: "my-3 flex items-center",
                                            children: [
                                              JsxRuntime.jsx("img", {
                                                    className: "w-5 h-5",
                                                    src: StaticAsset.src("/static/icons/back-arrow.svg")
                                                  }),
                                              JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                                    className: "ml-4 text-white",
                                                    children: org.name
                                                  })
                                            ]
                                          }) : JsxRuntime.jsx(Buhta_cabinet__OrgSwitcher.make, {
                                            org: org,
                                            setBar: setBar
                                          }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                                  className: "text-white",
                                                  children: "Меню"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  className: "border-l border-asphalt-dark h-5"
                                                }),
                                            JsxRuntime.jsx("button", {
                                                  children: JsxRuntime.jsx("img", {
                                                        src: StaticAsset.src("/static/icons/close-white-24.svg")
                                                      }),
                                                  onClick: (function (param) {
                                                      Curry._1(onClose, undefined);
                                                    })
                                                })
                                          ],
                                          className: "flex items-center gap-2"
                                        })
                                  ],
                                  className: "flex justify-between items-center"
                                }),
                            className: "px-4"
                          }),
                      tmp,
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                          route: {
                                            TAG: /* Admin */7,
                                            _0: /* Main */0
                                          },
                                          className: "p-2 hover:bg-gray-pale block",
                                          onLinkClicked: (function (param) {
                                              Curry._1(setIsDropdownShown, (function (param) {
                                                      return false;
                                                    }));
                                            }),
                                          children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                children: "Админка"
                                              })
                                        }),
                                    JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                          route: {
                                            TAG: /* Profile */5,
                                            _0: /* General */0
                                          },
                                          className: "p-2 hover:bg-gray-pale block",
                                          onLinkClicked: (function (param) {
                                              Curry._1(setIsDropdownShown, (function (param) {
                                                      return false;
                                                    }));
                                            }),
                                          children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                children: "Настройки профиля"
                                              }),
                                          urlParams: {
                                            hd: [
                                              "return_to",
                                              currentUrlStr
                                            ],
                                            tl: /* [] */0
                                          }
                                        }),
                                    JsxRuntime.jsxs("button", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "text-alert",
                                                  children: "Выйти из аккаунта"
                                                }),
                                            JsxRuntime.jsx("img", {
                                                  className: "w-5 h-5",
                                                  src: StaticAsset.src("/static/icons/logout-red-20.svg")
                                                })
                                          ],
                                          className: "flex p-2 hover:bg-gray-pale justify-between w-full",
                                          onClick: (function (param) {
                                              window.location.href = "/logout";
                                            })
                                        })
                                  ],
                                  className: "bg-white w-60 p-2 shadow-kkms rounded absolute bottom-16"
                                }),
                            className: Cn.$plus("absolute inset-0 pl-4", Cn.on("hidden", !match$1[0])),
                            onClick: (function (param) {
                                Curry._1(setIsDropdownShown, (function (param) {
                                        return false;
                                      }));
                              })
                          })
                    ],
                    className: Cn.$plus(Cn.$plus("fixed inset-0 bg-black z-50 pt-2.5", Cn.on("block", isOpen)), Cn.on("hidden", !isOpen))
                  });
      };
    };
  };
}

function SidebarMobile(Props) {
  return Curry._2(make$1(Props.org)(Props.isOpen), Props.onClose, Props.sidebarItems);
}

const make$2 = SidebarMobile;

export {
  SidebarMain ,
  make$2 as make,
}
/* Buhta_cabinet__Link Not a pure module */
